export var degreesToRadians = function degreesToRadians(degrees) {
  return Math.PI / 180 * degrees;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vx/shape/esm/util/trigonometry.js
// module id = 341
// module chunks = 0